module.exports = __webpack_public_path__ + "static/media/hakutsuru.8d03ae1c.png";